import { Box, BoxProps, styled } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import { sendMetricEvent } from 'features/metrics/model/metricsMutations'
import { MetricEventType } from 'features/metrics/api/metrics'

type BoxWithBackgroundImgProps = BoxProps & { backgroundImage: string }
const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'backgroundImage'
})<BoxWithBackgroundImgProps>(({ theme, backgroundImage }) => ({
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2.5),
  paddingRight: theme.spacing(16),
  cursor: 'pointer',
  transition: 'all .3s ease',

  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  width: '100%',

  '&:hover': {
    boxShadow: theme.shadows[4]
  }
}))

const Title = styled(Typography)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  marginBottom: theme.spacing(0.75),
  color: `${theme.palette.common.black} !important`
}))

const Description = styled(Typography)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  color: `${theme.palette.text.secondary} !important`,
  maxWidth: theme.spacing(34)
}))

export function NewsBox({ title, description, link, image }) {
  const handleClick = () => {
    sendMetricEvent(MetricEventType.HelpSidebarBlockClick, {
      resource: 'whats-new'
    })
    window.open(link, '_blank', 'noopener,noreferrer')
  }

  return (
    <Container onClick={handleClick} backgroundImage={image} aria-label="whats-new">
      <Title variant="body2" fontWeight="bold">
        {title}
      </Title>
      <Description variant="body2">{description}</Description>
    </Container>
  )
}

export default NewsBox
